import React, { ReactNode } from "react";
import NextImage from "@/components/shared/NextImage";
import { cn } from "@/libs/utils";
import Image from "next/image";

interface SoftwareFeaturesCardProps {
  desktopImgSrc: string;
  mobileImgSec: string;
  isImageRight?: boolean;
  contents: ReactNode;
  isPriority: boolean;
}
function SoftwareFeaturesCard({
  desktopImgSrc,
  mobileImgSec,
  isImageRight = false,
  contents,
  isPriority,
}: SoftwareFeaturesCardProps) {
  return (
    <article
      className={`flex flex-col gap-x-6 gap-y-8 md:gap-y-10 ${
        isImageRight ? "md:flex-row-reverse" : "md:flex-row"
      }`}
    >
      <figure className="flex-1">
        <Image
          src={desktopImgSrc}
          alt={desktopImgSrc}
          width={720}
          height={500}
          priority={isPriority}
          className="hidden w-full rounded-2xl object-cover transition-transform duration-300 ease-in-out group-hover:scale-105 xs:block"
        />
        <Image
          src={mobileImgSec}
          alt={mobileImgSec}
          width={384}
          height={316}
          priority={isPriority}
          className="block w-full rounded-2xl object-cover transition-transform duration-300 ease-in-out group-hover:scale-105 xs:hidden"
        />
      </figure>

      {/* contents section */}
      <div className="flex flex-1 flex-col justify-center">{contents}</div>
    </article>
  );
}

export default SoftwareFeaturesCard;
